import ManualPoll from './ManualPoll';
import PollRemainingTime from './PollRemainingTime';
import PublishHelper, { PublishHelperProps } from './PublishHelper';
import SlideIdentifier from './SlideIdentifier';
import useLeftPart from './vm';

export interface LeftPartProps extends Pick<PublishHelperProps, 'triggerValidations' | 'errors'> {
  isPollPublished: boolean;
  isPresenting: boolean;
}

const LeftPart = ({ isPollPublished, isPresenting, triggerValidations, errors }: LeftPartProps) => {
  const { isPollManual } = useLeftPart();

  if (isPollPublished) {
    if (isPollManual) return <ManualPoll />;
    return <PollRemainingTime />;
  }

  if (isPresenting) return <PublishHelper triggerValidations={triggerValidations} errors={errors} />;

  return <SlideIdentifier />;
};

export default LeftPart;
